<div>
    <da-tabs>
        <ng-container *ngIf="data">
            <ng-container *ngFor="let tab of data.tabs">
                <da-tab [tabTitle]="tab.label">
                    <div [innerHtml]="tab.section.copytext"></div>
                    <div class="boxes"></div>
                </da-tab>
            </ng-container>
        </ng-container>
        <ng-container *ngIf="course">
            <da-tab [tabTitle]="'courses.tabTitle1' | translate" *ngIf="description">
                <div *ngIf="isString$ | async" [innerHTML]="description"></div>
                <div *ngIf="!(isString$ | async)">
                    <ng-container *ngIf="site === 'de_de' && course.training.descriptionShort">
                        <h2>Kurzbeschreibung</h2>
                        <p>{{ course.training.descriptionShort }}</p>
                    </ng-container>
                    <ng-container *ngFor="let desc of description; let i=index">
                        <ng-container *ngIf="site === 'de_de' && i !== 0 || site !== 'de_de'">
                            <h2>{{ desc.Title }}</h2>
                            <div *ngFor="let item of desc.Paragraphs">
                                <p>{{ item.Text }}</p>
                                <ul *ngIf="item.SubTexts">
                                    <li *ngFor="let subtext of item.SubTexts">{{ subtext }}</li>
                                </ul>
                            </div>
                        </ng-container>
                    </ng-container>
                </div>
                <div class="boxes"></div>
            </da-tab>
        </ng-container>
        <ng-container *ngIf="showEventTab">
                <da-tab [tabTitle]="'courses.tabTitle2' | translate">
                    <da-events *ngIf="course && course.events && course.events.length > 0" [isCourseDetails]="true" [events]="course.events" [course]="course"></da-events>
                    <p *ngIf="course && (!course.events || course.events.length === 0)"[innerHTML]="'courses.noEventsAvailable' | translate"></p>
                    <div class="boxes"></div>
                </da-tab>
        </ng-container>
    </da-tabs>
</div>
